module.exports = __webpack_public_path__ + "img/202509-2_01.63176643.jpg";